<div id="vt-student-exit-survey-report" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16" [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
                    shopping_basket
                </mat-icon>
                <span class="logo-text h1" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
                    VT STUDENT EXIT SURVEY
                    <a [routerLink]="['./']" class="refresh-data export-excel mt-24 mt-md-0" matTooltip="Refresh"
                        matTooltipPosition="right">
                        <mat-icon [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">refresh</mat-icon>
                    </a>
                </span>
            </div>
            <!-- / APP TITLE -->

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter (keyup)="applySearchFilter($event.target.value)"
                        placeholder="Search for a VT Student Exit Survey" matTooltip="Search within display results"
                        matTooltipPosition="below">
                </div>
            </div>
            <!-- / SEARCH -->

            <!-- ADD BUTTON -->
            <div class="action-buttons">

                <a  class="export-excel"  class="export-excel" (click)="exportFilterData()"  matTooltip="Download with filters data">
                    <mat-icon color="primary"> cloud_download</mat-icon>
                </a>
                <a  class="export-excel"  class="export-excel" (click)="exportBulkData()"  matTooltip="Download all data">
                    <mat-icon> cloud_download</mat-icon>
                </a>
                
            </div>
            <!-- / ADD BUTTON -->
        </div>
        <!-- / HEADER -->

        <!-- Filter Section -->
        <div class="filter-content-card">
            <div class="filter-content">
                <form name="vtStudentExitSurveyForm" [formGroup]="vtStudentExitSurveyForm" class="exit-survey-report"
                    fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" fxFlex>

                    <div fxLayout="row" fxLayout.lt-md="column" class="input-row" fxLayoutGap="10px"
                        fxLayoutGap.lt-md="0px">

                        <mat-form-field fxFlex="30" fxFlex.lt-md="75" fxFlex.lt-sm="100">
                            <mat-label> Academic Year</mat-label>

                            <mat-select formControlName="AcademicYearId" name="academicYearId" appearance="fill"
                                required>
                                <mat-option [value]="academicYearItem.Id"
                                    *ngFor="let academicYearItem of academicyearList">
                                    {{ academicYearItem.Name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field fxFlex="20" fxFlex.lt-md="75" fxFlex.lt-sm="100">
                            <mat-label>Class</mat-label>

                            <mat-select formControlName="ClassId" name="classId" appearance="fill" required>
                                <mat-option [value]="classItem.Id" *ngFor="let classItem of classList">
                                    {{ classItem.Name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field fxFlex="20" fxFlex.lt-md="75" fxFlex.lt-sm="100" class="adjust-alignment">
                            <mat-label>Student Unique Id</mat-label>

                            <input matInput name="studentUniqueId" formControlName="StudentUniqueId"
                                placeholder="Student Unique Id" appearance="fill"
                                matTooltip="Search by Student Unique Id" matTooltipPosition="below">
                        </mat-form-field>

                        <div class="clear-filter pr-1" fxFlex="20" fxFlex.lt-md="75" fxFlex.lt-sm="100"
                            style="height: 60px;">
                            <button mat-raised-button class="fuse-white filter-button"
                                (click)="onLoadStudentExitSurveyReportByCriteria()" matTooltip="Search with filters"
                                matTooltipPosition="below"><span>SEARCH</span></button>
                            <button mat-raised-button class="fuse-white filter-button" (click)="resetFilters()"
                                matTooltip="Reset search filters" matTooltipPosition="below"><span>CLEAR</span></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- /Filter Section -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <mat-table class="vt-student-exit-survey-report-table responsive-table" [dataSource]="tableDataSource"
                matSort fusePerfectScrollbar [fusePerfectScrollbarOptions]="{'suppressScrollX': false}">

                <!-- AcademicYear Column -->
                <ng-container matColumnDef="AcademicYear">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Academic Year
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.AcademicYear}}</p>
                    </mat-cell>
                </ng-container>

                <!-- VTPName Column -->
                <ng-container matColumnDef="VTPName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>VTPName
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.VTPName}}</p>
                    </mat-cell>
                </ng-container>

                <!-- VCName Column -->
                <ng-container matColumnDef="VCName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>VCName
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.VCName}}</p>
                    </mat-cell>
                </ng-container>

                <!-- VTName Column -->
                <ng-container matColumnDef="VTName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>VTName
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.VTName}}</p>
                    </mat-cell>
                </ng-container>

                <!-- VTMobile Column -->
                <ng-container matColumnDef="VTMobile">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>VT Mobile
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.VTMobile}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Sector Column -->
                <ng-container matColumnDef="Sector">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Sector
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.Sector}}</p>
                    </mat-cell>
                </ng-container>

                <!-- JobRole Column -->
                <ng-container matColumnDef="JobRole">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>JobRole
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.JobRole}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Division Column -->
                <ng-container matColumnDef="Division">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Division
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.Division}}</p>
                    </mat-cell>
                </ng-container>

                <!-- District Column -->
                <ng-container matColumnDef="District">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>District
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.District}}</p>
                    </mat-cell>
                </ng-container>

                <!-- NameOfSchool Column -->
                <ng-container matColumnDef="NameOfSchool">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>School
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.NameOfSchool}}</p>
                    </mat-cell>
                </ng-container>

                <!-- UdiseCode Column -->
                <ng-container matColumnDef="UdiseCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>School Udise
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.UdiseCode}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Class Column -->
                <ng-container matColumnDef="Class">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Class
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.Class}}</p>
                    </mat-cell>
                </ng-container>

                <!-- SeatNo Column -->
                <ng-container matColumnDef="SeatNo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Seat No.
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.SeatNo}}</p>
                    </mat-cell>
                </ng-container>

                <!-- StudentUniqueId Column -->
                <ng-container matColumnDef="StudentUniqueId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Student Unique Id
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.StudentUniqueId}}</p>
                    </mat-cell>
                </ng-container>

                <!-- StudentFullName Column -->
                <ng-container matColumnDef="StudentFullName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Student Full Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.StudentFullName}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Gender Column -->
                <ng-container matColumnDef="Gender">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Gender
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.Gender}}</p>
                    </mat-cell>
                </ng-container>

                <!-- DOB Column -->
                <ng-container matColumnDef="DOB">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Date Of Birth
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.DOB | date: Constants.ShortDateFormat}}
                        </p>
                    </mat-cell>
                </ng-container>

                <!-- FatherName Column -->
                <ng-container matColumnDef="FatherName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Father Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.FatherName}}</p>
                    </mat-cell>
                </ng-container>

                <!-- MotherName Column -->
                <ng-container matColumnDef="MotherName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Mother Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.MotherName}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Category Column -->
                <ng-container matColumnDef="Category">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Category
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.Category}}</p>
                    </mat-cell>
                </ng-container>

                <!-- Religion Column -->
                <!-- <ng-container matColumnDef="Religion">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Religion
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.Religion}}</p>
                    </mat-cell>
                </ng-container> -->

                <!-- StreamName Column -->
                <ng-container matColumnDef="StreamName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Stream
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.StreamName}}</p>
                    </mat-cell>
                </ng-container>

                <!-- StudentMobileNo Column -->
                <ng-container matColumnDef="StudentMobileNo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Student Mobile No
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.StudentMobileNo}}</p>
                    </mat-cell>
                </ng-container>

                <!-- StudentWhatsAppNo Column -->
                <ng-container matColumnDef="StudentWhatsAppNo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Student WhatsApp No
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.StudentWhatsAppNo}}</p>
                    </mat-cell>
                </ng-container>

                <!-- ParentMobileNo Column -->
                <ng-container matColumnDef="ParentMobileNo">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Parent Mobile No
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.ParentMobileNo}}</p>
                    </mat-cell>
                </ng-container>

                <!-- CityOfResidence Column -->
                <ng-container matColumnDef="CityOfResidence">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>City Of Residence
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.CityOfResidence}}</p>
                    </mat-cell>
                </ng-container>

                <!-- DistrictOfResidence Column -->
                <ng-container matColumnDef="DistrictOfResidence">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>District Of Residence
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.DistrictOfResidence}}</p>
                    </mat-cell>
                </ng-container>

                <!-- BlockOfResidence Column -->
                <ng-container matColumnDef="BlockOfResidence">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Block Of Residence
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.BlockOfResidence}}</p>
                    </mat-cell>
                </ng-container>

                <!-- PinCode Column -->
                <ng-container matColumnDef="PinCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>PinCode
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.PinCode}}</p>
                    </mat-cell>
                </ng-container>

                <!-- StudentAddress Column -->
                <ng-container matColumnDef="StudentAddress">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Student Address
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.StudentAddress}}</p>
                    </mat-cell>
                </ng-container>

                <!-- DoneInternship Column -->
                <ng-container matColumnDef="DoneInternship">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Internship Status
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.DoneInternship === '1'">Yes</p>
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.DoneInternship === '0'">No</p>
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.DoneInternship == ''">NA</p>
                    </mat-cell>
                </ng-container>

                <!-- DoneInternship Column -->
                <!-- <ng-container matColumnDef="InternshipCompletedSector">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Internship Completed
                        Sector
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.InternshipCompletedSector}}</p>
                    </mat-cell>
                </ng-container> -->

                <!-- WillContHigherStudies Column -->
                <ng-container matColumnDef="WillContHigherStudies">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Name of the course to be pursued
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WillContHigherStudies}}</p>
                    </mat-cell>
                </ng-container>

                <!-- IsFullTime Column -->
                <ng-container matColumnDef="IsFullTime">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>IsFullTime
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.IsFullTime==318">Full Time</p>
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.IsFullTime==319">Part Time</p>
                    </mat-cell>
                </ng-container>

                <!-- CourseToPursue Column -->
                <ng-container matColumnDef="CourseToPursue">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>CourseToPursue
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.CourseToPursue}}</p>
                    </mat-cell>
                </ng-container>

                <!-- OtherCourse Column -->
                <ng-container matColumnDef="OtherCourse">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Other Course Details
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.OtherCourse}}</p>
                    </mat-cell>
                </ng-container>

                <!-- StreamOfEducation Column -->
                <ng-container matColumnDef="StreamOfEducation">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>StreamOfEducation
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.StreamOfEducation}}</p>
                    </mat-cell>
                </ng-container>

                <!-- OtherStreamStudying Column -->
                <ng-container matColumnDef="OtherStreamStudying">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Other Stream Studying
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.OtherStreamStudying}}</p>
                    </mat-cell>
                </ng-container>

                <!-- WillContVocEdu Column -->
                <ng-container matColumnDef="WillContVocEdu">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>WillContVocEdu
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WillContVocEdu}}</p>
                    </mat-cell>
                </ng-container>

                <!-- WillContVocational11 Column -->
                <ng-container matColumnDef="WillContVocational11">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>WillContVocational11
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WillContVocational11}}</p>
                    </mat-cell>
                </ng-container>

                <!-- ReasonsNOTToContinue Column -->
                <!-- <ng-container matColumnDef="ReasonsNOTToContinue">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Reasons NOT To Continue
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.ReasonsNOTToContinue}}</p>
                    </mat-cell>
                </ng-container> -->

                <!-- WillContSameSector Column -->
                <ng-container matColumnDef="WillContSameSector">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Will Cont Same Sector
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WillContSameSector}}</p>
                    </mat-cell>
                </ng-container>

                <!-- SectorForTraining Column -->
                <!-- <ng-container matColumnDef="SectorForTraining">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Sector For Training
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.SectorForTraining}}</p>
                    </mat-cell>
                </ng-container> -->

                <!-- OtherSector Column -->
                <!-- <ng-container matColumnDef="OtherSector">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Other Sector
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.OtherSector}}</p>
                    </mat-cell>
                </ng-container> -->

                <!-- CurrentlyEmployed Column -->
                <ng-container matColumnDef="CurrentlyEmployed">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Currently Employed
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.CurrentlyEmployed}}</p>
                    </mat-cell>
                </ng-container>

                <!-- WorkTitle Column -->
                <ng-container matColumnDef="WorkTitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Work Title
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WorkTitle}}</p>
                    </mat-cell>
                </ng-container>

                <!-- DetailsOfEmployment Column -->
                <ng-container matColumnDef="DetailsOfEmployment">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Details Of Employment
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.DetailsOfEmployment}}</p>
                    </mat-cell>
                </ng-container>

                <!-- WillBeFullTime Column -->
                <ng-container matColumnDef="WillBeFullTime">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Will Be FullTime
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WillBeFullTime}}</p>
                    </mat-cell>
                </ng-container>

                <!-- SectorsOfEmployment Column -->
                <ng-container matColumnDef="SectorsOfEmployment">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>SectorsOfEmployment
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.SectorsOfEmployment}}</p>
                    </mat-cell>
                </ng-container>

                <!-- IsVSCompleted Column -->
                <ng-container matColumnDef="IsVSCompleted">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>IsVSCompleted
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.IsVSCompleted}}</p>
                    </mat-cell>
                </ng-container>

                <!-- WantToPursueAnySkillTraining Column -->
                <ng-container matColumnDef="WantToPursueAnySkillTraining">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        WantToPursueAnySkillTraining
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WantToPursueAnySkillTraining}}</p>
                    </mat-cell>
                </ng-container>

                <!-- IsFulltimeWillingness Column -->
                <ng-container matColumnDef="IsFulltimeWillingness">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>IsFulltimeWillingness
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.IsFulltimeWillingness}}</p>
                    </mat-cell>
                </ng-container>

                <!-- HveRegisteredOnEmploymentPortal Column -->
                <ng-container matColumnDef="HveRegisteredOnEmploymentPortal">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        HveRegisteredOnEmploymentPortal
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.HveRegisteredOnEmploymentPortal}}</p>
                    </mat-cell>
                </ng-container>

                <!-- EmploymentPortalName Column -->
                <!-- <ng-container matColumnDef="EmploymentPortalName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        Employment Portal Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.EmploymentPortalName}}</p>
                    </mat-cell>
                </ng-container> -->

                <!-- WillingToGetRegisteredOnNAPS Column -->
                <ng-container matColumnDef="WillingToGetRegisteredOnNAPS">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        WillingToGetRegisteredOnNAPS
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WillingToGetRegisteredOnNAPS}}</p>
                    </mat-cell>
                </ng-container>

                <!-- IntrestedInJobOrSelfEmploymentPost12th Column -->
                <ng-container matColumnDef="IntrestedInJobOrSelfEmploymentPost12th">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        IntrestedInJobOrSelfEmploymentPost12th
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.IntrestedInJobOrSelfEmploymentPost12th}}</p>
                    </mat-cell>
                </ng-container>

                <!-- PreferredLocations Column -->
                <ng-container matColumnDef="PreferredLocations">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        PreferredLocations
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.PreferredLocations}}</p>
                    </mat-cell>
                </ng-container>

                <!-- PreferredLocations Column -->
                <!-- <ng-container matColumnDef="ParticularLocation">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        ParticularLocation
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.ParticularLocation}}</p>
                    </mat-cell>
                </ng-container> -->

                <!-- WantToKnowAboutOpportunities Column -->
                <ng-container matColumnDef="WantToKnowAboutOpportunities">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        WantToKnowAboutOpportunities
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.WantToKnowAboutOpportunities}}</p>
                    </mat-cell>
                </ng-container>

                <!-- CanLahiGetInTouch Column -->
                <ng-container matColumnDef="CanLahiGetInTouch">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>CanLahiGetInTouch
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.CanLahiGetInTouch}}</p>
                    </mat-cell>
                </ng-container>

                <!-- WantToKnowAbtPgmsForJobsNContEdu Column -->
                <ng-container matColumnDef="WantToKnowAbtPgmsForJobsNContEdu">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        WantToKnowAboutPgmsForJobsNContEdu
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.WantToKnowAbtPgmsForJobsNContEdu === '1'">
                            Yes</p>
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.WantToKnowAbtPgmsForJobsNContEdu === '0'">No
                        </p>
                        <p class="text-truncate" *ngIf="vtStudentExitSurvey.WantToKnowAbtPgmsForJobsNContEdu == ''">NA
                        </p>
                    </mat-cell>
                </ng-container>

                <!-- CollectedEmailId Column -->
                <ng-container matColumnDef="CollectedEmailId">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>CollectedEmailId
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.CollectedEmailId}}</p>
                    </mat-cell>
                </ng-container>

                <!-- SurveyCompletedByStudentORParent Column -->
                <ng-container matColumnDef="SurveyCompletedByStudentORParent">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>
                        SurveyCompletedByStudentORParent
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.SurveyCompletedByStudentORParent}}</p>
                    </mat-cell>
                </ng-container>

                <!-- DateOfIntv Column -->
                <ng-container matColumnDef="DateOfIntv">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Date of Survey Completion / Last Status
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.DateOfIntv | date: Constants.ShortDateFormat}}
                        </p>
                    </mat-cell>
                </ng-container>

                <!-- Remark Column -->
                <ng-container matColumnDef="Remark">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Remark
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.Remark}}</p>
                    </mat-cell>
                </ng-container>

                <!-- ExitSurveyStatus Column -->
                <ng-container matColumnDef="ExitSurveyStatus">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Exit Survey Status
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.ExitSurveyStatus}}</p>
                    </mat-cell>
                </ng-container>

                <!-- SubmissionDate Column -->
                <ng-container matColumnDef="SubmissionDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header fxShow.lt-sm fxShow.gt-md>Submission Date
                    </mat-header-cell>
                    <mat-cell *matCellDef="let vtStudentExitSurvey">
                        <p class="text-truncate">{{vtStudentExitSurvey.SubmissionDate}}</p>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let vtStudentExitSurvey; columns: displayedColumns;"
                    class="vt-student-exit-survey-report" matRipple>
                </mat-row>
            </mat-table>

            <div class="no-data-found" *ngIf="tableDataSource.data.length === 0">No records found!</div>

            <mat-paginator #ListPaginator [length]="SearchBy.TotalResults" [pageIndex]="SearchBy.PageIndex"
                [pageSize]="SearchBy.PageSize" [pageSizeOptions]="SearchBy.PageSizeOptions"
                [showFirstLastButtons]="SearchBy.ShowFirstLastButtons" (page)="onPageIndexChanged($event)">
            </mat-paginator>
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>